import { TriangleAlert } from 'lucide-react';
import { BrandLogo, Button } from '@/shared/ui';
import styles from './ErroInesperado.module.css';

export function ErroInesperado() {
  return (
    <main className={styles.pagina}>
      <div className={styles.card}>
        <BrandLogo height={36} />
        <div className={styles.icone} aria-hidden>
          <TriangleAlert size={28} />
        </div>
        <h1 className={styles.titulo}>Algo deu errado</h1>
        <p className={styles.texto}>
          Não foi possível continuar nesta tela. Recarregue a página para tentar de novo.
        </p>
        <Button type="button" onClick={() => window.location.reload()}>
          Recarregar
        </Button>
      </div>
    </main>
  );
}
